import Enumeration from './enum';

const ApplicationFeeEnum = new Enumeration({
  PERCENT: 'percent',
  CURRENCY: 'currency',
});

export function getFromApi(type) {
  if (type === '%') {
    return ApplicationFeeEnum.PERCENT;
  }

  if (type === '$') {
    return ApplicationFeeEnum.CURRENCY;
  }

  return null;
}

export default ApplicationFeeEnum;
